import { render, staticRenderFns } from "./AccountingStock.vue?vue&type=template&id=906e2d0e"
import script from "./AccountingStock.vue?vue&type=script&lang=ts"
export * from "./AccountingStock.vue?vue&type=script&lang=ts"
import style0 from "./AccountingStock.vue?vue&type=style&index=0&id=906e2d0e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('906e2d0e')) {
      api.createRecord('906e2d0e', component.options)
    } else {
      api.reload('906e2d0e', component.options)
    }
    module.hot.accept("./AccountingStock.vue?vue&type=template&id=906e2d0e", function () {
      api.rerender('906e2d0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/AccountingStock.vue"
export default component.exports